module.exports = __webpack_public_path__ + "img/wallet-pay-active.480aa32e.png";